export function resolveNativeTrackingUrls(candidates) {
    const urls = [];
    for (const candidate of candidates) {
        try {
            // En Android una ruta relativa apuntaría al WebView, no al servidor de la app.
            const url = new URL(candidate.url);
            if (['https:', 'http:'].includes(url.protocol)) urls.push(url.href);
        } catch {
            // La captura sigue usando la cola local si la configuración no es utilizable.
        }
    }
    return [...new Set(urls)];
}
